"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Text.css");
var Text = (function (_super) {
    __extends(Text, _super);
    function Text(props) {
        return _super.call(this, props) || this;
    }
    Text.prototype.render = function () {
        var _a = this.props, text = _a.text, toolTip = _a.toolTip, size = _a.size, color = _a.color, decoration = _a.decoration, weight = _a.weight, mode = _a.mode, wrapMode = _a.wrapMode, id = _a.id, role = _a.role;
        var cssClasses = generateClasses();
        function generateClasses() {
            var cssClasses = ['p-text'];
            cssClasses.push(constructClass(size, 'p-f-sz'));
            cssClasses.push(constructClass(color, 'p-t'));
            cssClasses.push(constructClass(decoration, 'p'));
            cssClasses.push(constructClass(weight, 'p-f-w'));
            if (wrapMode == 'Ellipsis') {
                cssClasses.push('p-t-wr-el');
            }
            else if (wrapMode == 'ForcedWrap' || text.indexOf(' ') < 0) {
                cssClasses.push('p-t-wr-fw');
            }
            return cssClasses.join(' ');
        }
        var attrs = {};
        if (this.props.tag != null)
            attrs["data-tag"] = this.props.tag;
        if (this.props.role != '')
            attrs["role"] = this.props.role;
        if (this.props.ariaHidden != undefined)
            attrs["aria-hidden"] = this.props.ariaHidden;
        function customizeEnums(en) {
            var cases = {
                'Xsmall': 'xs',
                'Small': 'sm',
                'Medium': 'md',
                'Large': 'lg',
                'Xlarge': 'xl',
                'Xlarge2': '2x',
                'Xlarge3': '3x',
                'Xlarge4': '4x',
                'Xlarge5': '5x',
                'Primary': 'Primary50',
                'Secondary': 'Secondary50',
                'Success': 'Success50',
                'Warning': 'Warning50',
                'Error': 'Error50',
                'Info': 'Info50',
                'Capitalize': 't-t-c',
                'Lowercase': 't-t-l',
                'Uppercase': 't-t-u',
                'Strikethrough': 't-d-lt',
                'Underline': 't-d-ul',
                'Italic': 'f-st-i',
                'Normal': 'n',
                'Bold': 'b',
                'SemiBold': '6'
            };
            return cases[en]
                ? cases[en].toLowerCase()
                : en.toLowerCase();
        }
        function constructClass(prop, prefix) {
            if (prop && prop !== 'None') {
                var customProp = customizeEnums(prop);
                return prefix + "-" + customProp;
            }
        }
        return (mode == 'Inline' ?
            React.createElement("span", __assign({ id: id, className: cssClasses, title: toolTip }, attrs), text) :
            React.createElement("p", __assign({ id: id, className: cssClasses, title: toolTip }, attrs), text));
    };
    return Text;
}(React.PureComponent));
Text.defaultProps = {
    text: '',
    toolTip: null,
    size: 'Medium',
    color: 'Default',
    decoration: 'None',
    weight: 'Normal',
    mode: 'Inline',
    wrapMode: 'None',
    tag: null,
    role: '',
    ariaHidden: undefined,
};
exports.Text = Text;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-controls'])
        csod.engine.controls['common-controls'] = {};
    csod.engine.controls['common-controls']['Text'] = Text;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Text"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-controls/controls/Text/Text.js
// module id = 60
// module chunks = 0 1